import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import update from 'react-addons-update';
import { Button } from 'semantic-ui-react';
import moment from 'moment-timezone';
moment.tz.setDefault('Asia/Seoul');
import { GiveDeduct, Commons } from 'components';

import * as cm_action from 'actions/commons';
import * as sd_action from 'actions/sikdae';

import toastr from 'helpers/toastr';
import cm from 'helpers/commons';

const propTypes = {};

const defaultProps = {};

class SikdaeGiveDeduct extends Component {
  constructor(props) {
    let type = window.location.search.substring(1).split('=')[1];
    super(props);
    this.state = {
      pagerow: null,
      allCheckkedCnt: 0,
      checkedCnt: 0,
      topMenu: {
        tabType: type ? type : 'give',
        nowStep: 'step1'
      },
      param: {
        keyword: null,
        groupid: null,
        auth: null,
        orgCode: null
      },
      actForm: {
        isChecked: false,
        staffCheckedData: [],
        isSave: false,
        groupNum: null,
        dataSet: null
      },
      auth: {
        give: false,
        deduct: false,
        schedule: false
      },
      allPolicy: 0,
      isLoadingBar: false,
      mealVoucher: cm.authGroupSet('meal-voucher')
    };
  }

  async componentWillMount() {
    //redux search props 초기화
    cm.propsInit(this.props);

    const { mealVoucher, param } = this.state;

    this.staffSel(param);
    await this.auth(); //권한 정도 set
    await this.sikdaeGroupSel(); //식대그룹 조회

    if (mealVoucher.schedule) {
      this.scheduleStartDate();
    }
  }

  componentDidMount() {
    cm.mainTitle('식대 지급/차감');
  }

  shouldComponentUpdate(nextProps, nextState) {
    let result = true;
    const { text, depth, auth, groupIdx } = this.props;
    const { text: nText, depth: nDepth, auth: nAuth, groupIdx: nGroupIdx } = nextProps;
    return !(text !== nText) && !(depth !== nDepth) && !(auth !== nAuth) && !(groupIdx !== nGroupIdx);
  }

  auth = () => {
    const { mealVoucher } = this.state;

    const auth = {
      give: false,
      deduct: false
    };

    //모든 권한
    if (mealVoucher.all) {
      auth['give'] = true;
      auth['deduct'] = true;
    }

    //식대 지급 권한이 있을 때
    if (mealVoucher.raise || mealVoucher.schedule) {
      auth['give'] = true;

      //지급 예약 권한 있을 때
      if (mealVoucher.schedule) {
        auth['schedule'] = true;
      }
    }
    //식대 차감 권한이 있을 때
    if (mealVoucher.lower) {
      auth['deduct'] = true;
    }

    this.setState({
      auth: auth
    });
  };

  //검색
  handleEntSubmit = async (e) => {
    if (e.key === 'Enter') {
      this.search();
    }
  };

  search = () => {
    const { groupIdx, auth, depth, text } = this.props;
    const { pagerow } = this.state;

    let keyword = text ? text.value : null;
    const params = {
      keyword: keyword ? keyword : null,
      groupid: groupIdx.value,
      orgCode: depth.value,
      grade: auth.value && auth.value !== 0 ? auth.value : null
    };
    this.setState({
      param: update(this.state.param, {
        keyword: { $set: keyword },
        groupid: { $set: groupIdx.value },
        orgCode: { $set: depth.value },
        grade: { $set: auth.value }
      })
    });

    this.staffSel(params);
    let isAllCntSet = true;
    for (let i in params) {
      if (params[i]) {
        isAllCntSet = false;
      }
    }

    if (isAllCntSet) {
      const { allCheckkedCnt, checkedCnt } = this.state;
      if (allCheckkedCnt > checkedCnt) {
        $('.allCheckbox').prop('checked', false);
      }
    } else {
      $('.allCheckbox').prop('checked', false);
    }
  };

  //식대그룹 조회
  sikdaeGroupSel = async () => {
    const { cmAPI } = this.props;
    this.setState({ isLoadingBar: true });

    try {
      await cmAPI.sikdaeGroupSel();

      const { sikdaeGroup } = this.props;

      if (sikdaeGroup && sikdaeGroup.data) {
        let idx = sikdaeGroup.data.group[0].idx;
        await cmAPI.sikdaePolicySel(idx);
      }
    } catch (e) {
      let response = e.response;

      if (response) {
        toastr('top-right', 'error', response.data.message);
      }

      console.log('###### sikdaeGroupSel Error : ', e);
    } finally {
    }
  };

  //step2 식대그룹 선택
  stepTwoSikdaeGroupClick = async (idx, name) => {
    $('.red.warning.circle.icon')
      .not('.checkIcon0')
      .css('display', 'none');
    $('.checkIcon0').css('display', 'unset');

    this.setState({
      actForm: update(this.state.actForm, { groupNum: { $set: idx } })
    });

    try {
      const { cmAPI } = this.props;
      await cmAPI.sikdaePolicySel(idx);
    } catch (e) {
      let response = e.response;
      if (response) {
        toastr('top-right', 'error', response.data.message);
      }

      console.log('###### stepTwoSikdaeGroupClick Error : ', e);
    } finally {
    }
  };

  //사용자 조회
  staffSel = async (params) => {
    const { cmAPI } = this.props;

    try {
      await cmAPI.staffSel(params);

      this.setState({
        actForm: update(this.state.actForm, { isSave: { $set: false } })
      });
    } catch (e) {
      const response = e.response;
      if (response) {
        toastr('top-right', 'error', response.data.message);
      }
    } finally {
      this.setState({ isLoadingBar: false });
    }
  };

  //상단 탭 이동
  tabMove = (type) => {
    this.setState({
      topMenu: update(this.state.topMenu, { tabType: { $set: type } })
    });
    var _tempUrl = window.location.search.substring(1);

    location.href = '/main/sikdaeGiveDeduct?type=' + type;
  };

  //step 이동
  stepMove = (step) => {
    const { actForm, param } = this.state;
    let result = false;

    if (step === 'step1') {
      result = true;

      this.setState({
        actForm: update(this.state.actForm, { isSave: { $set: result } })
      });
    } else if (step === 'step2') {
      if (actForm.staffCheckedData.length === 0) {
        toastr('top-right', 'warning', '임직원을 선택하세요.');
        result = false;
      } else {
        result = true;
      }
    } else if (step === 'step3') {
      result = this.step3DataSet();
    } else if (step === 'step4-1') {
      let result = this.isStep4DataSet();
      if (result) {
        this.step4DataSet();
      }
    } else if (step === 'step4') {
      result = true;
    }

    if (result) {
      this.setState({
        topMenu: update(this.state.topMenu, { nowStep: { $set: step } })
      });
    }
  };

  //식대 지급/차감
  giveDeduct = async (task) => {
    const { sdAPI } = this.props;
    const params = {
      task: task
    };

    try {
      await sdAPI.sikdaeGiveDeduct(params);
      this.stepMove('step4');
    } catch (e) {
      let response = e.response;
      if (response) {
        toastr('top-right', 'error', response.data.message);
      }
      console.log('###### giveDeduct Error : ', e);
    } finally {
      this.setState({ isLoadingBar: false });
    }
  };

  step4DataSet = () => {
    const { actForm, topMenu } = this.state;

    let task = [];

    if (actForm.dataSet.length > 0) {
      const { dataSet, staffCheckedData } = actForm;
      let sDate = null;
      dataSet.some((data) => {
        sDate = data.sDate;
        let params = {
          paytype: topMenu.tabType === 'give' ? 'PLUS' : 'MINUS',
          date: {
            reserve: topMenu.tabType === 'give' ? (sDate ? moment(sDate).toISOString() : null) : null,
            expire: topMenu.tabType === 'give' ? (data.eDate ? moment(data.eDate).toISOString() : null) : null
          },
          policy: {
            policyid: data.pIdx,
            groupid: data.gIdx
          },
          total: {
            amount: data.money,
            usercount: data.count
          },
          user: []
        };

        staffCheckedData.forEach((staff) => {
          if (data.pIdx === staff.sPolicy) {
            params['user'].push({
              id: staff.id,
              name: staff.name,
              cause: staff.reason,
              amount: staff.money
            });
          }
        });
        task.push(params);
      });

      this.giveDeduct(task);
    }
  };

  //최조 데이터 세팅 18!! 최종이다.
  isStep4DataSet = () => {
    this.setState({ isLoadingBar: true });
    const { actForm, topMenu } = this.state;
    let result = true;
    let suc = true;

    actForm.dataSet.some((data) => {
      if (suc) {
        if (topMenu.tabType === 'give') {
          if (!data.isDateSetting || !data.isMoneySetting) {
            if (!data.isDateSetting) {
              toastr('top-right', 'warning', data.title + ' 유효기간을 설정 해주세요.');
            } else {
              toastr('top-right', 'warning', data.title + ' 금액과 사유를 설정 해주세요.');
            }
            suc = false;
            result = false;
            this.setState({ isLoadingBar: false });
            return;
          }
        } else {
          if (!data.isMoneySetting) {
            toastr('top-right', 'warning', data.title + ' 금액과 사유를 설정 해주세요.');
            suc = false;
            result = false;
            this.setState({ isLoadingBar: false });
            return;
          }
        }
      }
    });

    return result;
  };

  step3DataSet = () => {
    const { actForm } = this.state;
    const staffCheckedData = actForm.staffCheckedData;

    let dataSet = [];
    let result = true;

    staffCheckedData.some((data) => {
      let title = null;
      let temp = {
        title: null,
        gIdx: data.group.idx,
        pIdx: null
      };

      if (data.sPolicy == 0 || !data.sPolicy) {
        toastr('top-right', 'warning', '식대정책을 선택하세요.');
        result = false;
        return true;
      }

      temp['title'] = data.group.name;
      temp['gIdx'] = data.group.idx;

      data.policy.some((item) => {
        if (item.idx == data.sPolicy) {
          temp['title'] += ' > ' + item.name;
          temp['pIdx'] += item.idx;
          temp['maxHoldLimitAmount'] = item.maxHoldLimitAmount;
          return true;
        }
      });

      if (dataSet.length > 0) {
        let isPush = dataSet.some((data) => {
          return data.gIdx == temp.gIdx && data.pIdx == temp.pIdx;
        });

        if (!isPush) {
          dataSet.push(temp);
        }
      } else {
        dataSet.push(temp);
      }
    });

    if (result) {
      dataSet.sort(function(a, b) {
        return a['gIdx'] - b['gIdx'];
      });

      this.setState({
        actForm: update(this.state.actForm, { dataSet: { $set: dataSet } })
      });
    }
    return result;
  };

  //사용자 체크박스 선택 on/off
  staffChecked = async (e, value, type) => {
    e.persist();
    let isChecked = e.target.checked;
    let isAllCntSet = true;
    const { param } = this.state;
    const params = {
      keyword: param.keyword,
      groupid: param.groupid,
      auth: param.auth,
      orgCode: param.orgCode
    };

    for (let i in params) {
      if (params[i]) {
        isAllCntSet = false;
      }
    }

    const { staffList } = this.props;
    const { actForm, checkedCnt } = this.state;
    const data = staffList ? staffList.data.user : null;
    let staffCheckedData = null;

    //전체 선택
    if (type === 'all') {
      await this.setState({
        isLoadingBar: true
      });
      const { staffList } = this.props;
      let data = staffList ? staffList.data.user : null;
      if (actForm.staffCheckedData.length > 0) {
        data = data.concat(actForm.staffCheckedData);
      }
      // 전체 on/off 된 데이터 반환
      staffCheckedData = cm.staffCheckedData(e.target, data, isChecked, 'all-filter', staffList.data.user);
      if (isAllCntSet) {
        await this.setState({ allCheckkedCnt: staffCheckedData.length });
      }
      await this.setState({ checkedCnt: staffCheckedData.length });
      this.setState({
        actForm: update(this.state.actForm, {
          isChecked: { $set: isChecked },
          staffCheckedData: { $set: staffCheckedData }
        })
      });

      await this.setState({
        isLoadingBar: false
      });
    } else {
      staffCheckedData = await cm.staffCheckedData(e.target, actForm.staffCheckedData, isChecked, 'each-filter', data);
      this.setState({
        actForm: update(this.state.actForm, {
          staffCheckedData: { $set: staffCheckedData }
        })
      });
    }

    const beforeCnt = this.state.checkedCnt;
    const afterCnt = staffCheckedData.length;
    if (beforeCnt !== 0 && beforeCnt > afterCnt) {
      $('.allCheckbox').prop('checked', false);
    }
  };

  stepThreeAllBtn = async (e, type, params) => {
    const { actForm } = this.state;

    let staffCheckedData = actForm.staffCheckedData;
    if (type === 'money') {
      if (params.type == 'oneByone') {
        staffCheckedData.some((data) => {
          if (data.id === params.id) {
            $(`#money-${data.id}`).val(e.target.value);
            data['money'] = cm.toInt(e.target.value);
            return true;
          }
        });
      } else {
        staffCheckedData.forEach((data) => {
          if (data.sPolicy === params.pIdx) {
            let val = cm.toInt(
              $(e.target)
                .parent()
                .children('input')
                .val()
            );
            if (val || val === 0) {
              $(`#money-${data.id}`).removeClass('value-null');
            }
            data['money'] = val;
            $(`#money-${data.id}`).val(val);
          }
        });
      }
    } else if (type === 'reason') {
      if (e.target.value.length > 50) {
        toastr('top-right', 'warning', '50자 이하로 입력해주세요.');
        e.target.value = e.target.value.substring(0, 50);
        return;
      }

      if (params.type == 'oneByone') {
        staffCheckedData.some((data) => {
          if (data.id === params.id) {
            data['reason'] = e.target.value;
            $(`#reason-${data.id}`).val(e.target.value);
          }
        });
      } else {
        staffCheckedData.forEach((data) => {
          if (data.sPolicy === params.pIdx) {
            let val = $(e.target)
              .parent()
              .children('input')
              .val();
            if (val && val !== '') {
              $(`#reason-${data.id}`).removeClass('value-null');
            }
            data['reason'] = val;
            $(`#reason-${data.id}`).val(val);
          }
        });
      }
    } else if (type === 'dateSetting') {
      staffCheckedData.forEach((data) => {
        if (data.sPolicy === params.pIdx) {
          data['eDate'] = params.endDate;
          data['sDate'] = params.startDate;
          data['time'] = params.time ? params.time.sTime : null;
        }
      });

      this.tabTotalData(type, params);
    }

    this.setState({
      actForm: update(this.state.actForm, { staffCheckedData: { $set: staffCheckedData } })
    });
  };

  /**
   * [ 각 정책별 설정 완료 데이터 세팅 ]
   * @param  {[string]} type    [ dateSetting : 날짜 설정, moneySetting : 금액 설정 ]
   * @param  {[array]} params   [ 설정 된 데이터 ]
   * @return {[array]}          [ 각 정책별 총 금액, 인원수 등등 종합한 데이터 ]
   */
  tabTotalData = (type, params) => {
    const { actForm, topMenu } = this.state;

    let dataSet = actForm.dataSet;

    if (type === 'dateSetting') {
      let time = params.time ? params.time.sTime : null;

      dataSet.some((item) => {
        if (item.pIdx === params.pIdx) {
          item['isDateSetting'] = params.isDateSetting;
          item['sDate'] = params.startDate ? params.startDate : null;
          item['eDate'] = params.endDate ? params.endDate : null;
          item['time'] = time ? time : null;
        }
      });
    } else if (type === 'moneySetting') {
      let isMinus = topMenu.tabType === 'give' ? '' : '(-)';
      let totlaMoney = '총 ' + params.totalCount + '명 / 총 ' + isMinus + cm.numberComma(params.totalMoney) + '원(장)';

      dataSet.some((item) => {
        if (item.pIdx === params.pIdx) {
          item['totalMoney'] = totlaMoney;
          item['isMoneySetting'] = params.isMoneySetting;
          item['money'] = params.totalMoney;
          item['count'] = params.totalCount;
        }
      });
    }

    this.setState({
      actForm: update(this.state.actForm, { dataSet: { $set: dataSet } })
    });
  };

  //step2 정책 모두 적용
  allBtn = (type, groupNum, value) => {
    const { actForm, allPolicy } = this.state;

    let staffCheckedData = actForm.staffCheckedData;

    if (type === 'policy') {
      // let groupNum = actForm.groupNum;

      $('.default-sel')
        .val(value)
        .prop('selected', true);

      if (value != 0) {
        $('.red.warning.circle.icon').css('display', 'none');
      } else {
        $('.red.warning.circle.icon').css('display', 'unset');
      }
      staffCheckedData.forEach((data) => {
        if (data.group.idx === groupNum) {
          data['sPolicy'] = Number(value);
        }
      });
    }
  };

  //식대그룹 selectbox
  selectBoxhandleChange = (e, type, value) => {
    const { actForm } = this.state;

    let groupNum = actForm.groupNum;
    let staffCheckedData = actForm.staffCheckedData;

    if (type !== 'all') {
      if (value !== 0) {
        $(e.target)
          .parent()
          .children('.red.warning.circle.icon')
          .css('display', 'none');
      } else {
        $(e.target)
          .parent()
          .children('.red.warning.circle.icon')
          .css('display', 'unset');
      }

      staffCheckedData.some((data) => {
        if (data.id === e.target.id) {
          data['sPolicy'] = Number(value);
          return;
        }
      });
    }
  };

  moveStaffExcel = async () => {
    const { excelMenuShow } = this.props;
    excelMenuShow();
    this.context.router.history.push('/main/sikdaeGiveDeductByExcel');
  };

  /**
   * [ 권한 중에 schedule 권한이 있을 때 식대지급 start 시간 조회 ]
   * @return {[type]} [description]
   */
  scheduleStartDate = async () => {
    try {
      const { sdAPI } = this.props;
      await sdAPI.scheduleStartDate(null);
    } catch (e) {
    } finally {
    }
  };

  render() {
    const { staffList } = this.props;
    const { topMenu, param, actForm, isLoadingBar, auth } = this.state;
    let userTotal = staffList && staffList.data && staffList.data.paging ? staffList.data.paging.totalcount : 0;

    const topMenuProps = {
      fn: {
        tabMove: this.tabMove,
        stepMove: this.stepMove
      },
      data: {
        topMenu: topMenu,
        auth: auth
      }
    };

    const searchFormProps = {
      fn: {
        handleEntSubmit: this.handleEntSubmit,
        search: this.search
      },
      data: {
        topMenu: topMenu,
        userTotal: userTotal,
        staffCheckedData: actForm.staffCheckedData
      }
    };

    const ActFormProps = {
      fn: {
        staffSel: this.staffSel,
        staffChecked: this.staffChecked,
        stepTwoSikdaeGroupClick: this.stepTwoSikdaeGroupClick,
        selectBoxhandleChange: this.selectBoxhandleChange,
        allBtn: this.allBtn,
        stepThreeAllBtn: this.stepThreeAllBtn,
        tabTotalData: this.tabTotalData
      },
      data: {
        param: param,
        staffCheckedData: actForm.staffCheckedData,
        isChecked: actForm.isChecked,
        isSave: actForm.isSave,
        groupNum: actForm.groupNum,
        dataSet: actForm.dataSet,
        topMenu: topMenu,
        isLoadingBar: isLoadingBar,
        auth: auth
      }
    };

    const bottomFormProps = {
      fn: {
        stepMove: this.stepMove
      },
      data: {
        topMenu: topMenu,
        actForm: actForm
      }
    };

    return (
      <main>
        {isLoadingBar ? <Commons.LoadingBar /> : null}
        <div className="top-btn button">
          <Button.Group>
            <Button inverted color="green" onClick={this.moveStaffExcel}>
              엑셀파일로 지급/차감하기
            </Button>
          </Button.Group>
        </div>
        <div className="sgd">
          <GiveDeduct.TopMenu fn={topMenuProps.fn} data={topMenuProps.data} />
          <div className="info-form">
            {topMenu.nowStep === 'step1' ? (
              <div className="search-form">
                <GiveDeduct.SearchForm fn={searchFormProps.fn} data={searchFormProps.data} />
              </div>
            ) : null}
            <GiveDeduct.ActForm fn={ActFormProps.fn} data={ActFormProps.data} />
          </div>
          <div className="bottom-form">
            <GiveDeduct.BottomForm fn={bottomFormProps.fn} data={bottomFormProps.data} />
          </div>
        </div>
      </main>
    );
  }
}

SikdaeGiveDeduct.propTypes = propTypes;
SikdaeGiveDeduct.defaultProps = defaultProps;

SikdaeGiveDeduct.contextTypes = {
  router: PropTypes.object.isRequired
};

SikdaeGiveDeduct = connect(
  (state) => ({
    staffList: state.commons.staff,
    groupIdx: state.commons.group,
    auth: state.commons.auth,
    depth: state.commons.depth,
    sikdaeGroup: state.commons.sikdaeGroup,
    text: state.commons.text
  }),
  (dispatch) => ({
    cmAPI: bindActionCreators(
      {
        sikdaeGroupSel: cm_action.SikdaeGroupList,
        sikdaePolicySel: cm_action.SikdaePolicyList,
        staffSel: cm_action.StaffSel
      },
      dispatch
    ),

    sdAPI: bindActionCreators(
      {
        sikdaeGiveDeduct: sd_action.SikdaeGiveDeduct,
        scheduleStartDate: sd_action.ScheduleStartDate
      },
      dispatch
    )
  })
)(SikdaeGiveDeduct);

export default SikdaeGiveDeduct;
